import PropTypes from "prop-types";
import React from "react";
import HealthReview from "../HealthReview";

const HRAResults = ({ data, client }) => {
  const { render, results } = data;

  // Temp solution to prevent showing new HRA widget implemation to BUPA
  if (client === "bupa" && render === "true") {
    return <HealthReview {...results} key={"HRAResults"} />;
  }

  return render === "true" &&
    results.assessmentStatus &&
    results.assessmentStatus.hraQuestionsAnswered === "true" ? (
    <HealthReview {...results} key={"HRAResults"} />
  ) : null;
};

HRAResults.propTypes = {
  data: PropTypes.shape({
    render: PropTypes.string.isRequired,
    results: PropTypes.object.isRequired,
  }),
  client: PropTypes.string,
};

export default HRAResults;



// WEBPACK FOOTER //
// ./components/dashboard/widgets/HRAResults.js